export default __webpack_public_path__ + "static/media/User_Edit.8bcf7346.svg";